module.exports = __webpack_public_path__ + "static/media/16_symbol_horseshoe_250k.82fdbfe6.png";